import React from "react";
import { object, string, array, bool } from "prop-types";
import { Link } from "@quintype/components";
import get from "lodash/get";
import { connect } from "react-redux";

import CardImage from "../../atoms/CardImage";
import Headline from "../../atoms/Headline";
import StoryMetaData from "../../molecules/StoryMetaData";

import "./customStoryCard6.m.css";

const CustomStoryCard6 = ({
  story,
  imageType = "image16x9",
  aspectRatio = [16, 9],
  isStoryMetaData = true,
  updatedFont = false,
  publisherAttributes,
  src,
}) => {
  const storyHeadlineStyle = updatedFont ? `${publisherAttributes.lang}-headline-style` : null;
  const customStoryHeadlineStyle = src ? `${publisherAttributes.lang}-headline-style-${src}` : storyHeadlineStyle;
  const headlineStyle = src ? customStoryHeadlineStyle : storyHeadlineStyle;

  return (
    <div styleName="wrapper" className="wrapper">
      <Link href={story.url} className="image-wrapper">
        <CardImage
          story={story}
          aspectRatio={aspectRatio}
          defaultWidth={330}
          imageType={imageType}
          showAlternateImage={true}
        />
      </Link>
      <div>
        <Link href={story.url}>
          <Headline text={story.headline} headlineType={34} styleName={headlineStyle} />
        </Link>
        {isStoryMetaData && <StoryMetaData story={story} />}
      </div>
    </div>
  );
};

CustomStoryCard6.propTypes = {
  story: object.isRequired,
  imageType: string,
  aspectRatio: array,
  isStoryMetaData: bool,
  updatedFont: bool,
  publisherAttributes: object,
  src: string,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

export default connect(mapStateToProps, null)(CustomStoryCard6);
